import script from "./MultiTagEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiTagEdit.vue?vue&type=script&setup=true&lang=js"

import "./MultiTagEdit.vue?vue&type=style&index=0&id=86fd5114&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86fd5114"]])

export default __exports__